module.exports = __webpack_public_path__ + "static/media/alarm.de6a6387.svg";